import React from 'react';
import cn from '@utils/cn';
import { TestimonialsType } from '@lib/sanity/queries/modules/testimonials/types';
import Visuals from '@ui/Visuals/Visuals';
import Anchor from '@ui/Anchor/Anchor';
import { Grid10ColOfFullWidth } from '@constants/layout';
import Text, { TextVariant } from '@ui/Text/Text';
import PortableText from '@ui/Text/PortableText';

type TestimonialProps = {
  testimonial: NonNullable<TestimonialsType['testimonials']>[0];
};

export default function Testimonial({ testimonial }: TestimonialProps) {
  const className = 'sm:items-center sm:text-center justify-center text-left justify-left';
  const backgroundColor = testimonial.background?.rgb?.a
    ? `rgba(${testimonial.background?.rgb.r}, 
        ${testimonial.background?.rgb.g}, 
        ${testimonial.background?.rgb.b}, 
        ${testimonial.background?.rgb.a})`
    : undefined;

  const foregroundColor = testimonial.foreground?.rgb?.a
    ? `rgba(${testimonial.foreground?.rgb.r}, 
        ${testimonial.foreground?.rgb.g}, 
        ${testimonial.foreground?.rgb.b}, 
        ${testimonial.foreground?.rgb.a})`
    : undefined;

  return (
    <div className={cn('relative shrink-0 grow-0  px-4 md:px-8', 'basis-[100%]  lg:basis-[75%] ')}>
      <div
        className={cn(
          'bg-tertiary flex h-full w-full flex-col ',
          'gap-6  px-4 py-24 sm:px-12 lg:px-24 xl:rounded-full',
          className,
          Grid10ColOfFullWidth,
        )}
        style={{ backgroundColor }}
      >
        <div className={cn('flex flex-col gap-4', className)}>
          <Visuals data={testimonial.logo} className="max-w-[150px] object-contain" />
          <PortableText
            content={testimonial.quote}
            variant={TextVariant.TextBlockquoteLG}
            style={{ color: foregroundColor }}
            className="text-foreground"
          />
        </div>
        <Anchor
          aria-label={testimonial.company?.text?.value ?? ''}
          className={cn('flex flex-col', className)}
          href={testimonial.company?.url || undefined}
        >
          <Text
            content={testimonial.name?.value}
            variant={TextVariant.SubtitleSM}
            style={{ color: foregroundColor }}
            className="text-foreground"
          />
          <Text
            content={testimonial.company?.text?.value}
            variant={TextVariant.SubtitleSM}
            style={{ color: foregroundColor }}
            className="text-foreground"
          />
        </Anchor>
      </div>
    </div>
  );
}
